<div class="navigation">
  <mat-list>

    <mat-list-item></mat-list-item>

    <a mat-list-item *hasAnyAuthority="VERWALTUNG_ERFASSUNGSWELLEN" class="navigation-item"
       routerLink="/erfassungswelle" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">format_align_left</mat-icon>
      <span>Erfassungswelle</span>
    </a>

    <a mat-list-item *hasAnyAuthority="VERWALTUNG_FRAGEBOEGEN" class="navigation-item"
       routerLink="/questionnaire" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">assignment_turned_in</mat-icon>
      <span>Fragebögen</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_FOTOS" class="navigation-item"
       routerLink="/picture" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">panorama</mat-icon>
      <span>Fotos</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_ZAEHLUNGEN" class="navigation-item"
       routerLink="/counting" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">exposure</mat-icon>
      <span>Zählungen</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_ANTWORTLISTEN" class="navigation-item"
       routerLink="/answer-list" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">list</mat-icon>
      <span>Antwortlisten</span>
    </a>

    <a mat-list-item *hasAnyAuthority="VERWALTUNG_FAHRPLAENE" class="navigation-item"
       routerLink="/schedule" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">departure_board</mat-icon>
      <span>Fahrpläne</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_FRAGEBOEGEN" class="navigation-item"
       routerLink="/answered-questionnaire" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">question_answer</mat-icon>
      <span>Beantwortete Fragebögen</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_MITTEILUNGEN" class="navigation-item"
       routerLink="/notification" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">chat</mat-icon>
      <span>Mitteilungen</span>
    </a>
    <a mat-list-item *hasAnyAuthority="VERWALTUNG_ADMIN" class="navigation-item"
       routerLink="/user-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
      <mat-icon class="dark-grey">people</mat-icon>
      <span>Benutzerverwaltung</span>
    </a>

    <mat-list-item class="navigation-item" role="button" (click)="logout()">
      <mat-icon class="dark-grey">power_settings_new</mat-icon>
      <span>Logout</span>
    </mat-list-item>
    <mat-divider></mat-divider>

  </mat-list>
  <div class="card-like-margin version bottom-list">
    <label>v.{{version}}</label>
  </div>

</div>
